<template>
  <div class="page-wallet">
    <FrameHeader/>

    <div class="block-papa">

      <!--  -->
      <div class="block-user pb-5">

        <CpBlockProfile :cfg="{
          auto_call_login: true,
        }"/>

        <div class="mt-4 tac">
          <span class="b" style="font-size: 20px; color: #EC5EFF;">
            ${{
              balance_total_on_usd 
              | tofixed2 
              | qfw
            }} 
            {{lg('',{
              en: 'USD',
              zh: '美元',
            })}}
          </span>
        </div>

        <div class="tac mt-4">
          <span 
            class="d-inline-bock cp c h-c"
            @click="showPopupAddFund()"
            >
            <i 
              class="far fa-arrow-alt-circle-down d-block"
              style="font-size: 28px;"
            ></i>
            <span class="small d-block">
              {{lg('',{
                en: 'Fund your wallet',
                zh: '充值钱包',
              })}}
            </span>
          </span>
        </div>
      </div>

      <!--  -->
      <div class="block-wallet pb-5 mb-5">

        <div class="ui-tabset-style2 size-lg default-gray">
          <span 
            :class="['tab',{on: on_tab === 'funds'}]"
            @click=" setTab('funds')"
            >
            {{lg('',{
              en: 'Funds',
              zh: '货币',
            })}}
          </span>
          <span 
            :class="['tab',{on: on_tab === 'activity'}]"
            @click=" setTab('activity')"
            >
            {{lg('',{
              en: 'Activity',
              zh: '交易记录',
            })}}
          </span>
        </div>

        <div>

          <!-- balance -->
          <div v-if="on_tab === 'funds'" class="px-4 pt-3">
            <div 
              v-for="(item,index) of account_wallet" 
              :key="index"
              class="border-bottom py-3"
              >
              <span class="ui-token-icon size-30 mr-1">
                <img :src="`/static/pic/token_icon/${($store.state.fecfg.cfg_dict_token_setting[item.id] || {}).icon}`">
              </span>
              <span>
                {{item.num | tofixed3| qfw}}
                {{lg('',item.names)}}
              </span>
              <span class="t-gray ml-3">
                (${{item.num | tokenToUsd(item.id) | qfw}}
                {{lg('',{
                  en: 'USD',
                  zh: '美元',
                })}})
              </span>
            </div>
          </div>

          <!-- activity -->
          <div v-if="on_tab === 'activity' && status_loading_history" class="tac t-gray p-5">
            Loading...
          </div>
          <BlockHistory v-if="on_tab === 'activity' && !status_loading_history" :list_history="list_history" class="px-4"/>
          <!-- <div v-if="on_tab === 'activity'" class="px-4">
            <div 
              v-for="(item,index) of list_activity" 
              :key="index"
              class="border-bottom py-3"
              >
              <span class="d-inline-block" style="min-width: 150px;">
                {{item.name}}
              </span>
              <span class="t-gray">
                5:00 PM, Oct. 15, 2020
              </span>
            </div>
          </div> -->
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import bus from '@/bus.js'
import BlockHistory from './blockHistory.vue'

export default {
  name: 'wallet',
  components: {
    BlockHistory,
  },
  props: [],
  data() {
    return {
      on_tab: 'funds', //funds activity

      account_wallet: this.$store.state.web3.account_wallet,

      // activity
      status_loading_history: false,
      list_history: [],

      // list_activity: [
      //   {
      //     id: '1',
      //     name: 'Receive',
      //   },
      //   {
      //     id: '2',
      //     name: 'Send',
      //   },
      //   {
      //     id: '3',
      //     name: 'Purchase',
      //   },
      //   {
      //     id: '4',
      //     name: 'sale',
      //   },
      // ],
    }
  },
  computed: {
    balance_total_on_usd(){
      let v = this

      let fn = v.$options.filters['tokenToUsd']

      let mark = 0

      v.$store.state.web3.account_wallet.forEach(function(item){
        let res = fn(item.num,item.id)
        if(typeof res === 'number'){
          mark += res
        }
      })

      return mark
    },
  },
  watch: {
    '$stroe.state.web3.account'(val){
      if(val){
        this.getHistory()
      }
    },
  },
  methods: {

    setTab(str){
      let v = this
      v.on_tab = str
      v.$router.replace({
        query: {
          tab: str,
        }
      })
      
      if(str==='activity' && v.list_history.length === 0){
        v.getHistory()
      }
    },

    async getHistory(){
      let v = this

      await v.uniGetCurrentBlockNum()

      if(v.list_history.length === 0){
        v.status_loading_history = true
      }

      let res = await v.api('list_my_history',{
        address: v.$store.state.web3.account,
      },{
        vue: v,
        key_data: 'list_history',
      })

      v.status_loading_history = false
    },
    
    checkTab(){
      let v = this
      let query_str = v.$route.query.tab
      if( query_str ||  ['funds','activity'].indexOf(query_str) >= 0){
        v.setTab(query_str)
      }
    },

    showPopupAddFund(){
      bus.appvue.showPopupAddFund({
        token_type: 'token',
        nft_name: '-',
        on_step: 'step_qrcode',
      })
    },
  },
  created() {
    this.checkTab()
    this.uniGetWalletBalance()
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/vars.scss';

  .page-wallet{

    
    @media(min-width: 788px){
      .block-papa{
        display: flex;
        .block-user{
          width: 240px;
          height: 100%;
          position: sticky; top: 70px; z-index: 10;
        }
        .block-wallet{
          border-left: 1px solid $c_border;
          min-height: 80vh;
          flex: 1;
        }
      }
    }
  }
</style>